import React from 'react';
import { SingleStepType } from './types';
import styles from './Steps.module.scss';
import SingleStep from './SingleStep';
import { useWindowSize } from 'src/hooks/useWindowSize';
import { DeviceContext } from '../DeviceProvider/DeviceProvider';
import { byHideOnPredicate } from '../../utils/filterPredicates/hideOn';

export interface StepsPropTypes {
  visible: boolean;
  title: string;
  steps: (SingleStepType & { hide_on?: string[] })[];
  omit_index_prefix: boolean;
  onStepItemClick?: (args: { stepTitle: string }) => void;
}

const Steps: React.FC<StepsPropTypes> = ({
  visible = true,
  title,
  steps,
  omit_index_prefix = false,
  onStepItemClick,
}) => {
  const width = useWindowSize().width;
  const { deviceOs } = React.useContext(DeviceContext);

  if (!visible || !steps.length) return null;

  const getProps = (
    step: SingleStepType,
    index: number
  ): { step: SingleStepType; index?: number } => ({
    step,
    ...(omit_index_prefix ? {} : { index }),
  });

  return (
    <div className={styles.wrapper} data-testid="steps-wrapper">
      <div className={styles.title} data-testid="steps-title">
        {title}
      </div>
      <div className={styles.stepWrapper} data-testid="step-wrapper">
        {steps
          .filter(byHideOnPredicate({ width, deviceOs }))
          .map((step: SingleStepType, index: number) => (
            <SingleStep
              key={step.title}
              {...getProps(step, index)}
              onClick={onStepItemClick}
            />
          ))}
      </div>
    </div>
  );
};

export default Steps;
